import React from "react";
import * as styles from "./RepeatableList.module.scss";
import classNames from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import Button from "@app/components/Button";
import FormBuilderElements from "@app/components/FormBuilder/FormBuilderElements";
import { getInitialValues } from "@app/components/FormBuilder/FormBuilder";
import { FieldArray, useField } from "formik";
//import PropTypes from 'prop-types'

const RepeatableList = ({ name, button = "Hinzufügen", elements /*values*/ }) => {
	const RepeatableListClassName = classNames({
		[styles["repeatable-list"]]: true,
	});
	const [{ value } /*meta*/] = useField({ name });

	const mapWithName = (array, index) => {
		return array.map((elem) => ({
			...elem,
			name: `${name}.${index}.${elem.name}`,
		}));
	};

	const mapWithNameObj = (object, index) => {
		let newObject = {};

		Object.entries(object).forEach(([key, val]) => {
			newObject[`${name}.${index}.${key}`] = val;
		});

		return newObject;
	};

	return (
		<>
			<Container className={RepeatableListClassName}>
				<Row>
					<Col xs={12}>
						<FieldArray name={name}>
							{({ push, remove }) => (
								<>
									{value?.length > 0
										? value.map((currentValue, index) => (
												<div key={index} className={styles["list-item"]}>
													<Row>
														<FormBuilderElements
															values={{
																...getInitialValues(mapWithName(elements, index)),
																...mapWithNameObj(currentValue, index),
															}}
															displayFields={mapWithName(elements, index)}
														/>
													</Row>

													<div className={styles["list-item-action"]}>
														{index > 0 ? (
															<Button
																type={"tertiary"}
																iconBefore={"bin"}
																callback={() => {
																	console.log("callback-button Delete");
																	remove(index);
																}}
															/>
														) : (
															""
														)}
													</div>
												</div>
											))
										: ""}

									<Row>
										<Col xs={6} sm={4}>
											<Button
												label={button}
												type={"quaternary"}
												big={true}
												iconBefore={"add"}
												iconSize={12}
												callback={() => push(getInitialValues(elements))}
											/>
										</Col>
									</Row>
								</>
							)}
						</FieldArray>
					</Col>
				</Row>
				{/*{meta.error && (
					<Row>
						<Col>{meta.error}</Col>
					</Row>
				)}*/}
			</Container>
		</>
	);
};

RepeatableList.propTypes = {};

export default RepeatableList;
